import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';

function useFormValidation(initialState, validate) {
  const [values, setValues] = useState(initialState);
  const [errors, setErrors] = useState({});

  const resetError = name => setErrors(prevState => ({ ...prevState, [name]: undefined }));

  const handleChange = event => {
    const { name, value } = event.target;
    resetError(name);
    setValues(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const resetValues = useCallback(values => {
    setValues(values);
  }, []);

  const handleBlur = event => {
    const { name } = event.target;
    const validationErrors = validate(values);
    setErrors(prevState => ({ ...prevState, [name]: validationErrors[name] }));
  };

  const handleSubmit = event => {
    event.preventDefault();
    const validationErrors = validate(values);
    if (values.aggregator && values.schema && !JSON.parse(values.schema).properties?.[values.aggregator]) {
      toast.error('El campo agrupador debe ser uno de los campos definidos en el esquema', {
        position: 'top-center',
        autoClose: 4000,
        hideProgressBar: true,
        closeOnClick: true,
      });
      return false
    }
    if (values.identifier && values.schema && !JSON.parse(values.schema).properties?.[values.identifier]) {
      toast.error('El campo identificador debe ser uno de los campos definidos en el esquema', {
        position: 'top-center',
        autoClose: 4000,
        hideProgressBar: true,
        closeOnClick: true,
      });
      return false
    }
    setErrors(validationErrors);
    return Object.entries(validationErrors).length === 0;
  };

  return {
    handleSubmit,
    handleChange,
    handleBlur,
    values,
    errors,
    setErrors,
    resetValues,
  };
}

export default useFormValidation;
